/* eslint-disable @typescript-eslint/no-unused-vars */
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, CanMatch, Route, Router, RouterStateSnapshot, UrlSegment, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { filter, map, switchMap, take } from 'rxjs/operators';
import { OktaAuthStateService } from '@okta/okta-angular';
import { environment as env } from '../../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class AdminGuard implements CanMatch, CanActivate {
  constructor(
    private stateService: OktaAuthStateService,
    private router: Router,
  ) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | UrlTree | Observable<boolean | UrlTree> | Promise<boolean | UrlTree> {
    return this.stateService.hasAnyGroups(env.adminRole).pipe(
      take(1),
      map((isIngroup) => {
        if (isIngroup) return true;
        this.router.navigate(['/']);
        return false;
      }),
    );
  }

  canMatch(route: Route, segments: UrlSegment[]): boolean | UrlTree | Observable<boolean | UrlTree> | Promise<boolean | UrlTree> {
    // Wait for Okta auth state to be fully initialized before checking permissions
    // The authState$ observable uses startWith(false), so we filter to wait for real auth state
    // Only proceed when we have evidence that Okta has loaded (tokens present or isAuthenticated is true)
    return this.stateService.authState$.pipe(
      filter((authState) => {
        const hasTokens = !!(authState.accessToken || authState.idToken);
        return authState.isAuthenticated === true || hasTokens;
      }),
      take(1),
      switchMap((authState) => {
        if (!authState.isAuthenticated) {
          this.router.navigate(['/']);
          return [false];
        }

        return this.stateService.hasAnyGroups(env.adminRole).pipe(
          take(1),
          map((isInGroup) => {
            if (isInGroup) {
              return true;
            }
            this.router.navigate(['/']);
            return false;
          }),
        );
      }),
    );
  }
}
